// extracted by mini-css-extract-plugin
export default {"container":"MediaPage_container__yWOUg"};